import ImagePreviewWithCarousel from './imagePreviewWithCarousel'

export default ImagePreviewWithCarousel
